export function findClosestValueIndex(values, currentValue) {
  var result = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);
    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }
    return acc;
  }, null);
  if (result) {
    return result.index;
  }
  return 0;
}